var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticStyle:{"width":"50px"}},[_vm._t("first-column")],2),_c('td',{staticStyle:{"width":"50px"}},[_vm._t("second-column")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }